import { CertificateState } from "@/core/models/certificate";

export default {
  setCertificates: (state: CertificateState, payload: Array<any>) => {
    state.certifications = payload;
  },
};
